import { DeviceInfo,QPInfoManager } from 'qunar-react-native';
// 处理微信  订单路径转换
const fixWxOrderUrl = (url: string) => {
    if(!url){
        return;
    }
    const page = url.slice(0, url.indexOf('?'));
    const query = url.slice(url.indexOf('?'));
    let u;
    switch (page) {
        case '/hotel/pages/hotel/hotel-order-detail/hotel-order-detail':
            u = '/pages/hotel/pages/hotel-order-detail/hotel-order-detail';
            break;
        case '/train/pages/orderDetail/orderDetail':
            u = '/pages/train/orderDetail/index';
            break;
        case '/vacation/pages/orderDetail/index':
            u = '/pages/vacation/orderDetail/index';
            break;
        case '/ticket/pages/orderdetail/orderdetail':
            u = '/pages/ticket/orderDetail/index';
            break;
        case '/pages/business/bus/pages/orderDetail/orderDetail':
            u = '/pages/bus/orderDetail/index';
            break;
        case '/pages/business/flight/orderDetail/orderDetail':
            u = '/flight/pages/orderDetail/orderDetail';
            break;
        case '/bus/pages/orderDetail/orderDetail':
            u = '/pages/bus/orderDetail/index';
            break;
        case '/hotel/pages/hotel/hotel-comment/hotel-comment':
            u = '/pages/hotel/pages/hotel-comment/hotel-comment';
            break;
        default:
            u = page;
            break;

    }
    return (u + query);
}
//获取 biz_assign_version
const getBizVersion = async (hybridId = 'cmn_order_rn') => {
    return new Promise((resolve, reject) => {
        let extMap = {};
        QPInfoManager.getQpInfo(
            hybridId,
            (qpInfo: { biz_assign_version:any }) => {
                const { biz_assign_version } = qpInfo || {};
                // console.log('biz_assign_version',biz_assign_version)
                extMap.biz_assign_version = biz_assign_version;
                resolve(extMap);
            },
            () => {
                extMap.biz_assign_version = '';
                resolve(extMap);
            }
        );
    });
}
export default {
    fixWxOrderUrl,
    getBizVersion
}